import {Stack, Typography, useTheme} from '@mui/material';
import React from 'react';

import Icon from 'presentation/icons';
import {FeatureItemProps} from './types';

export function FeatureItem({feature, iconSize}: FeatureItemProps) {
	const theme = useTheme();

	return (
		<Stack direction="row" alignItems="flex-start" gap={1}>
			<Icon name={feature.iconName} color={theme.palette.primary.main} size={iconSize} />
			<Stack>
				<Typography variant="body1" color="text.primary" fontWeight={600}>
					{feature.title}
				</Typography>
				{feature.description ? (
					<Typography variant="body2" color="text.secondary">
						{feature.description}
					</Typography>
				) : null}
			</Stack>
		</Stack>
	);
}
